import { getHeroContentGroupStarter } from './hero-content-group';
import { starterChild } from './slot';
import type { StarterChild } from './slot';

export type HeroStarterChild =
  | StarterChild
  | {
      type: 'HeroContentGroup';
      props: { content: StarterChild[]; desktopLayout: 'row'; mobileLayout: 'column' };
    };

/**
 * Returns the complete slot tree used by every newly inserted or pre-seeded Hero.
 *
 * The content group starts with two Buttons as a convenience, while its slot remains open to any
 * number and order of Heading, Text, Button and Image children. Authors can also keep those same
 * child types directly in the Hero instead of using a group.
 *
 * IDs are intentionally absent at every level. Puck recursively stamps fresh IDs when a Hero is
 * inserted; pre-seeded page data adds stable IDs in `default-hero.ts` instead.
 */
export function getHeroStarterChildren(): HeroStarterChild[] {
  return [
    starterChild('Heading', {
      text: '<p style="text-align: center">Your headline</p>',
      level: 'h1',
      preset: 'h1',
    }),
    starterChild('Paragraph', {
      text: '<p style="text-align: center">Add a short description that supports your headline.</p>',
    }),
    {
      type: 'HeroContentGroup',
      props: {
        content: getHeroContentGroupStarter(),
        desktopLayout: 'row',
        mobileLayout: 'column',
      },
    },
  ];
}
